module.exports = __webpack_public_path__ + "mainassets/img/color-rectangle.edafa52b.png";